/**
 * Wall component - defines wall segment properties for auto-connecting walls
 * Walls automatically connect to adjacent wall segments and update their variant
 */

// Direction bitmask for wall connections
export const WallDirection = {
  NORTH: 1,  // +Z
  EAST: 2,   // +X
  SOUTH: 4,  // -Z
  WEST: 8,   // -X
} as const;

// Wall variant types based on connections
export type WallVariant = 'single' | 'end' | 'straight' | 'corner' | 'tee' | 'cross';

export interface WallComponent {
  tileX: number;           // Tile X coordinate
  tileZ: number;           // Tile Z coordinate
  connections: number;     // Bitmask of connected directions
  variant: WallVariant;    // Current visual variant
  rotation: number;        // Rotation in radians for proper orientation
}

export function createWallComponent(tileX: number, tileZ: number): WallComponent {
  return {
    tileX,
    tileZ,
    connections: 0,
    variant: 'single',
    rotation: 0,
  };
}
